































































import Component from 'vue-class-component';
import { Prop, Vue } from 'vue-property-decorator';
import ProductListTracker from '@/project/tracking/gtm/ProductListTracker.vue';
import { ProductTileViewObject } from '@/types/apiServerContract';
import SmartHeadline from '@/core/ui-components/SmartHeadline.vue';
import { ProductRelationType } from './constants';
import breakpointState from '@/core/responsive/breakpoints/breakpointsState.observable';
import { MIN_LG } from '@/core/config/breakpointConfig';
import breakpointService from '@/core/responsive/breakpoints/breakpoints.service';

@Component({
    components: { ProductListTracker, SmartHeadline }
})
export default class CondensedProductList extends Vue {
    @Prop({
        required: true,
        type: Array
    })
    products!: ProductTileViewObject[];

    @Prop({
        required: true,
        type: String
    }) trackingListName!: string;

    @Prop({
        required: false,
        type: String,
        default: null
    }) headline!: string | null;

    @Prop({
        required: false,
        type: String,
        default: 'text-18 md:text-36 font-regular'
    })
    headlineClasses!: string;

    @Prop({
        required: false,
        type: Boolean,
        default: false
    }) isFirstBlock!: boolean;

    @Prop({
        required: false,
        type: String,
        default: null
    }) productBgColor!: string | null;

    @Prop({
        required: false,
        type: String,
        default: null
    }) relationType!: ProductRelationType | null;

    @Prop({
        type: Boolean,
        default: false
    }) useSwiper!: boolean;

    @Prop({
        type: Number
    }) listViewPageSize!: number | undefined;

    page: number = 1;
    slidesPerView: 6 | 'auto' = 6; // Desktop (LG and XL) 6, else 'auto'
    rendered: boolean = false;
    activeBreakpoint: string = '';

    get listViewProducts() {
        return this.products.filter((p, index) => this.listViewPageSize === undefined || index < this.page * this.listViewPageSize);
    }

    handleNextPage() {
        this.page++;
    }

    get productColor() {
        if (!this.productBgColor) return '';

        switch (this.productBgColor.toLowerCase()) {
        case 'white':
            return 'bg-white';
        case 'gray':
            return 'bg-gray-300';
        }
    }

    get id() {
        return new Date().valueOf();
    }

    get prevButtonSelector() {
        return 'custom-swiper-button-prev-' + this.id;
    }

    get nextButtonSelector() {
        return 'custom-swiper-button-next-' + this.id;
    }

    handleBreakpointChange() {
        const newBreakpoint = breakpointService.getActiveBreakpoint();
        if (newBreakpoint !== this.activeBreakpoint) {
            this.activeBreakpoint = newBreakpoint;
            this.rendered = false;
            this.setSlidesPerView();
            this.$nextTick(() => this.rendered = true);
        }
    }

    mounted() {
        this.activeBreakpoint = breakpointService.getActiveBreakpoint();
        breakpointService.addListener(this.handleBreakpointChange);
        this.setSlidesPerView();
        this.$nextTick(() => {
            this.rendered = true;
        });
    }

    destroyed() {
        breakpointService.removeListener(this.handleBreakpointChange);
    }

    setSlidesPerView() {
        this.slidesPerView = breakpointState.isBreakpointActive(MIN_LG) ? 6 : 'auto';
    }

    get sliderOptions() {
        return {
            spaceBetween: 10,
            slidesPerView: this.slidesPerView,
            slidesPerGroup: 1,
            loop: false,
            loopFillGroupWithBlank: false,
            watchSlidesVisibility: true,
            watchOverflow: true,
            setWrapperSize: true,
            navigation: {
                nextEl: '.' + this.nextButtonSelector,
                prevEl: '.' + this.prevButtonSelector
            },
            grabCursor: true,
            instanceName: this.id,
            observer: true,
            observeParents: true,
            observeSlideChildren: true
        };
    }
}
